import { Device } from "@/utils/device"
import type { MenuProps } from "../menu.props"
import { BannerMenu } from "./BannerMenu"
import { ItemsMenuChild } from "./ItemMenuChild"
import { slugify } from "@/utils/slugify"
import { webPath } from "@/utils/webPath"

export function Menu({
    tituloGrupoMenu,
    grupoMenu,
    menu,
    device,
    hostImagem
}: Readonly<MenuProps>) {
    function getMidiaUrl(path: string, nomeArquivo: string): string {
        return hostImagem + '/' + path + nomeArquivo
    }
    
    return (
        <div className="container">
            {tituloGrupoMenu && (
                <div className="title-ctn">
                    <h2 className="bg-title">
                        <span>{tituloGrupoMenu}</span>
                    </h2>
                </div>
            )}

            <div className="box-menu-widget">
                <ul id={`menu-widget-${grupoMenu}`} className={`menu-size-${menu ? menu.length : 0}`}>
                    {menu && menu.map((item) => (
                        <li key={item.id}
                            className={`menu-list-${item.id} ${item.childs.length > 0 ? 'has-childs' : 'not-has-childs'} ${slugify(item.nome)} item-menu-${slugify(item.nome)}`}
                        >
                            <a
                                href={webPath(item.link)}
                                className={`menu-link-${item.id} ${item.childs.length > 0 ? 'has-childs' : 'not-has-childs'}`}
                            >
                                <span className={`menu-icon ${!(item.icone_midia_path && item.icone_midia_arquivo_nome) && 'no-icon'}`}>
                                    {(device == Device.DESKTOP && item.icone_midia_path && item.icone_midia_arquivo_nome) && (
                                        <img
                                            className="h-auto"
                                            src={getMidiaUrl(item.icone_midia_path, item.icone_midia_arquivo_nome)}
                                            alt={item.icone_midia_path && item.icone_midia_arquivo_nome}
                                        />
                                    )}
                                </span>
                                <span className="menu-text" dangerouslySetInnerHTML={{ __html: item.nome }} />
                            </a>

                            <BannerMenu item={item} device={device} hostImagem={hostImagem} />

                            {item.childs.length > 0 && (
                                <ItemsMenuChild
                                    item={item} 
                                    device={device}
                                    hostImagem={hostImagem}
                                />
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}